import request from '@/utils/request'

/**
 * 站点配置接口
 *
 * 后端字段为 snake_case，页面沿用项目统一的驼峰写法，转换收在本文件里。
 *
 * 注意保存语义：
 *   POST /site_config 是**全量覆盖**——未传或传 null 的字段会被存成空字符串，
 *   并且每次保存都会把旧配置置为历史（active=2）后插入一条新配置。
 *   因此页面无论在哪个 Tab 点保存，都必须提交完整的 7 个字段，
 *   否则其它 Tab 的配置会被清空。
 */

/**
 * 响应 -> 前端
 * 没有 active=1 的配置时后端返回 data 为 null
 */
function normalize (data) {
  return {
    title: (data && data.title) || '',
    siteDomain: (data && data.site_domain) || '',
    searchPlaceholder: (data && data.search_placeholder) || '',
    csUrl: (data && data.cs_url) || '',
    everyDaySlogan: (data && data.every_day_slogan) || '',
    favNotice: (data && data.fav_notice) || '',
    hotKeywords: (data && data.hot_keywords) || ''
  }
}

/**
 * 前端 -> 请求
 */
function toPayload (form) {
  return {
    title: form.title || '',
    site_domain: form.siteDomain || '',
    search_placeholder: form.searchPlaceholder || '',
    cs_url: form.csUrl || '',
    every_day_slogan: form.everyDaySlogan || '',
    fav_notice: form.favNotice || '',
    hot_keywords: form.hotKeywords || ''
  }
}

/**
 * 获取当前站点配置
 */
export function getSiteConfig () {
  return request({
    url: '/site_config',
    method: 'get'
  }).then(res => {
    const body = res.data
    if (body && body.code === 0) {
      body.data = normalize(body.data)
    }
    return res
  })
}

/**
 * 保存站点配置（全量覆盖）
 */
export function saveSiteConfig (form) {
  return request({
    url: '/site_config',
    method: 'post',
    data: toPayload(form)
  })
}

/**
 * 各字段的最大长度，与后端校验保持一致
 */
export const FIELD_MAX_LENGTH = {
  title: 100,
  siteDomain: 100,
  searchPlaceholder: 100,
  csUrl: 100,
  everyDaySlogan: 100,
  favNotice: 1000,
  hotKeywords: 1000
}
